import {createContext, memo, type SetStateAction, useMemo, useState} from 'react'

const DialogType = {
  None: 'none',
  AddColumn: 'add-column',
  IssueFields: 'issue-fields',
} as const

type DialogType = (typeof DialogType)[keyof typeof DialogType]

type AddFieldModalContextType = {
  /** setter for controlling modal visibility */
  setShowAddFieldModal: React.Dispatch<SetStateAction<boolean>>
  /** boolean for whether the modal is open */
  showAddFieldModal: boolean
  /** current dialog state within the modal */
  dialog: DialogType
  /** setter for updating the dialog state */
  setDialog: React.Dispatch<SetStateAction<DialogType>>
}

export const AddFieldModalContext = createContext<AddFieldModalContextType | null>(null)

export const AddFieldModalContextProvider = memo(function AddFieldModalContextProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [showAddFieldModal, setShowAddFieldModal] = useState(false)
  const [dialog, setDialog] = useState<DialogType>(DialogType.None)

  const contextValue = useMemo<AddFieldModalContextType>(
    () => ({
      showAddFieldModal,
      setShowAddFieldModal,
      dialog,
      setDialog,
    }),
    [showAddFieldModal, dialog],
  )

  return <AddFieldModalContext.Provider value={contextValue}>{children}</AddFieldModalContext.Provider>
})

export {DialogType}

try{ AddFieldModalContext.displayName ||= 'AddFieldModalContext' } catch {}
try{ AddFieldModalContextProvider.displayName ||= 'AddFieldModalContextProvider' } catch {}